import React from "react";
import * as S from "./styles";
import InputSubText from "../InputSubText";
import InputCompleteSubText from "../InputCompleteText";
import { editCompleteText, editCompleteTitle, InputTypes, StateProps } from "../../store";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

const CompleteInputBox = ({
  completeTitleAlert,
  setCompleteTitleAlert,
}: {
  completeTitleAlert: boolean;
  setCompleteTitleAlert: (alert: boolean) => void;
}) => {
  const { control, register } = useForm();
  const { formEtcs } = useSelector((state: StateProps) => state);
  const dispatch = useDispatch();
  const completeTitle = formEtcs.completeTitle || "";
  const completeText = formEtcs.completeText || "";

  return (
    <S.Container>
      <Controller
        name="CardTitle"
        control={control}
        render={() => (
          <S.TitleField
            id="filled-basic"
            value={completeTitle}
            alert={completeTitleAlert}
            onChange={(e) => {
              setCompleteTitleAlert(false);
              dispatch(editCompleteTitle({ completeTitle: e.target.value }));
            }}
            placeholder="제목을 입력해주세요"
            variant="filled"
          />
        )}
      />
      <InputCompleteSubText completeText={completeText} />
    </S.Container>
  );
};

export default CompleteInputBox;
